import PropTypes from 'prop-types';
import React, { Component } from 'react';

class Metrics extends Component {
  render() {
    return (
      <div className="metrics-container">
        <div className="total-hours">
          <h2>PROGRESS</h2>
          <div>
            {this.phraseCalc()}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a onClick={this.callToggleRecordListen} id="recordListenToggle">
              {
                this.props.recordingScreen ?
                  (
                    <span>
                      Listen to recorded phrases &#8250;&#8250;&#8250;
                    </span>
                  ) :
                  (
                    <span>
                      Continue recording...
                    </span>
                  )
              }
            </a>
          </div>
          <div>
            {this.timeRecorded()}
          </div>
        </div>
        <div className="speech-rate">
          <h2>SPEECH RATE</h2>
          <div>{this.speechRate()}</div>
        </div>
      </div>
    );
  }

  userCalc = () => {
    if (this.props && typeof this.props.totalPrompt !== 'undefined') {
      return `Your Email: ${this.props.currentUser}`;
    }
  };

  phraseCalc = () => {
    if (this.props && typeof this.props.totalPrompt !== 'undefined') {
      return `Recorded Phrases: ${this.props.promptNum} / ${this.props.totalPrompt} ( ${Math.round((this.props.promptNum * 100 / this.props.totalPrompt) * 100) / 100}% )`;
    }
  };

  timeRecorded = () => {
    if (this.props && typeof this.props.totalTime !== 'undefined') {
      return `Time Recorded: ${this.secondsToHms(Math.round(this.props.totalTime))}`;
    }
  };

  speechRate = () => {
    if (this.props && typeof this.props.totalTime !== 'undefined' && typeof this.props.totalCharLen !== 'undefined') {
      let charPerSec = (this.props.totalCharLen / this.props.totalTime).toFixed(1);
      charPerSec = isNaN(charPerSec) ? 0 : charPerSec;

      return `Average: ${charPerSec} characters per second`;
    }
  };

  secondsToHms = d => {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };

  callToggleRecordListen = () => {
    this.props.toggleRecordListen();
  };
}

Metrics.propTypes = {
  promptNum: PropTypes.number,
  totalCharLen: PropTypes.number,
  totalTime: PropTypes.number,
  totalPrompt: PropTypes.number,
  recordingScreen: PropTypes.bool,
  toggleRecordListen: PropTypes.func,
}

export default Metrics;



// WEBPACK FOOTER //
// ./src/App/components/Metrics.js